import * as React from 'react';
import { Icon, DropdownItemProps } from "semantic-ui-react";

export enum DartsGameStatus {
    Undefined = 0,
    NotActive = 1,
    Running = 2,
    Delayed = 3,
    Suspended = 4,
    Postponed = 5,
    Walkover = 6,
    Abandoned = 7,
    Cancelled = 8,
    PreEnd  = 9,
    End = 10
}

export type TDartsGameStatuses =
    DartsGameStatus.Undefined |
    DartsGameStatus.NotActive |
    DartsGameStatus.Running |
    DartsGameStatus.Delayed |
    DartsGameStatus.Suspended |
    DartsGameStatus.Postponed |
    DartsGameStatus.Walkover |
    DartsGameStatus.Abandoned |
    DartsGameStatus.Cancelled |
    DartsGameStatus.PreEnd |
    DartsGameStatus.End;


export const DartsGameStatusesForDropDown: Record<DartsGameStatus, { name: string; color: string }> = {
    [DartsGameStatus.Undefined]: { name: 'question', color: 'grey' },
    [DartsGameStatus.NotActive]: { name: 'circle outline', color: 'grey' },
    [DartsGameStatus.Running]: { name: 'play', color: 'green' },
    [DartsGameStatus.Delayed]: { name: 'clock outline', color: 'orange' },
    [DartsGameStatus.Suspended]: { name: 'pause', color: 'yellow' },
    [DartsGameStatus.Postponed]: { name: 'calendar times', color: 'orange' },
    [DartsGameStatus.Walkover]: { name: 'flag outline', color: 'blue' },
    [DartsGameStatus.Abandoned]: { name: 'ban', color: 'red' },
    [DartsGameStatus.Cancelled]: { name: 'close', color: 'red' },
    [DartsGameStatus.PreEnd]: { name: 'hourglass half', color: 'grey' },
    [DartsGameStatus.End]: { name: 'stop', color: 'black' },
};

export const DartsGameStatusesForScoring: DropdownItemProps[] = [
    { key: DartsGameStatus.Undefined, value: DartsGameStatus.Undefined, text: DartsGameStatus[DartsGameStatus.Undefined].toLowerCase(), image: <Icon name="question" color="grey" /> },
    { key: DartsGameStatus.NotActive, value: DartsGameStatus.NotActive, text: 'not active', image: <Icon name="circle outline" color="red" /> },
    { key: DartsGameStatus.Running, value: DartsGameStatus.Running, text: DartsGameStatus[DartsGameStatus.Running].toLowerCase(), image: <Icon name="play" color="green" /> },
    { key: DartsGameStatus.PreEnd, value: DartsGameStatus.PreEnd, text: 'pre-end', image: <Icon name="hourglass half" color="orange" /> },
    { key: DartsGameStatus.End, value: DartsGameStatus.End, text: DartsGameStatus[DartsGameStatus.End].toLowerCase(), image: <Icon name="stop" color="red" /> },
    { key: 'divider', divider: true, disabled: true },
    { key: DartsGameStatus.Delayed, value: DartsGameStatus.Delayed, text: DartsGameStatus[DartsGameStatus.Delayed].toLowerCase(), image: <Icon name="clock outline" color="yellow" /> },
    { key: DartsGameStatus.Suspended, value: DartsGameStatus.Suspended, text: DartsGameStatus[DartsGameStatus.Suspended].toLowerCase(), image: <Icon name="pause" color="yellow" /> },
    { key: DartsGameStatus.Postponed, value: DartsGameStatus.Postponed, text: DartsGameStatus[DartsGameStatus.Postponed].toLowerCase(), image: <Icon name="calendar times" color="orange" /> },
    { key: DartsGameStatus.Abandoned, value: DartsGameStatus.Abandoned, text: DartsGameStatus[DartsGameStatus.Abandoned].toLowerCase(), image: <Icon name="ban" color="orange" /> },
    { key: DartsGameStatus.Cancelled, value: DartsGameStatus.Cancelled, text: DartsGameStatus[DartsGameStatus.Cancelled].toLowerCase(), image: <Icon name="close" color="red" /> },
    { key: DartsGameStatus.Walkover, value: DartsGameStatus.Walkover, text: DartsGameStatus[DartsGameStatus.Walkover].toLowerCase(), image: <Icon name="flag outline" color="red" /> },
]
